import { Select, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import { IconPlus } from "../../utils/icons";
import AchievementBox from "../AchievementBox";
import AddInternationalAchivementModal from "../AllModal/AddInternationalAchivementModal";
import toastMessage from "../../utils/toastMessage";
import { updateUserFormsDetails } from "../../services/awsServices";
import { getUserAllFormsDetails } from "../../slices/userSlice";

function AchievementsCard({ title, gold, silver, bronze }) {
  console.log("🚀 ~ AchievementsCard ~ title:", title);
  console.log("🚀 ~ AchievementsCard ~ silver:", silver);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAchievement, setSelectedAchievement] = useState("all"); // Step 1: Manage selection state
  const dispatch = useDispatch();
  // Step 2: Update selection on change
  const handleChange = (value) => {
    setSelectedAchievement(value);
  };

  console.log({ gold });
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  const btnDisableCond =
    basicInfoData?.IsFinalSubmit && basicInfoData?.IsFinalSubmit;
  const deleteAchievement = (type, index) => {
    const updatedData = [...type]; // Create a copy of the array
    updatedData[0] = { ...updatedData[0] }; // Create a copy of the inner object
    updatedData[0].Data = [...updatedData[0].Data]; // Create a copy of the inner array
    updatedData[0].Data.splice(index, 1); // Modify the copied array
    delete updatedData[0].PK;
    const dataSand = {
      Data: updatedData[0].Data,
      SK: updatedData[0].SK,
    };
    updateUserFormsDetails(dataSand)
      .then((res) => {
        console.log(res, " = res:updateBasicInfo");
        dispatch(getUserAllFormsDetails()).unwrap();
        toastMessage(
          // res.data?.message || "Achievement deleted successfully",
          "Achievement deleted successfully",
          "success"
        );
      })
      .catch((error) => {
        console.log(error, " = error:updateBasicInfo");
        toastMessage("Something went wrong", "error");
      });
  };

  return (
    <div className="space-y-5 shadow-[0px_4px_18px_0px_#4B465C1A] rounded-3xl p-5">
      <div className="lg:flex lg:items-center lg:justify-between ">
        <div className="flex items-center gap-3">
          <h1 className="bg-tabsTextStyle inline-block text-transparent bg-clip-text text-lg font-semibold">
            {title}
          </h1>
          <Select
            defaultValue={"all"}
            className="w-[200px]"
            onChange={handleChange}
          >
            <Select.Option value="all">
              {title === "International Achievements"
                ? "All International achievement"
                : "All national achievement"}
            </Select.Option>
            <Select.Option value="Gold">Gold</Select.Option>
            <Select.Option value="Silver">Silver</Select.Option>
            <Select.Option value="Bronze">Bronze</Select.Option>
          </Select>
        </div>
        <Tooltip
          title={
            btnDisableCond
              ? "Once you click on the 'Final Submission' button, you won't be able to change your details."
              : ""
          }
        >
          <button
            disabled={btnDisableCond}
            className="flex items-center gap-2 text-darkOrange"
            onClick={() => setIsModalOpen(true)}
          >
            Add Achievement <IconPlus color="#FF6B38" />
          </button>
        </Tooltip>
      </div>
      <p className="text-DarkGrey">
        Let us celebrate your outstanding achievements and share it with us !
      </p>
      {selectedAchievement === "all" || selectedAchievement === "Gold" ? (
        <AchievementBox
          data={gold}
          onDeleteItem={(index) => deleteAchievement(gold, index)}
        />
      ) : null}
      {selectedAchievement === "all" || selectedAchievement === "Silver" ? (
        <AchievementBox
          data={silver}
          onDeleteItem={(index) => deleteAchievement(silver, index)}
        />
      ) : null}
      {selectedAchievement === "all" || selectedAchievement === "Bronze" ? (
        <AchievementBox
          data={bronze}
          onDeleteItem={(index) => deleteAchievement(bronze, index)}
        />
      ) : null}
      <AddInternationalAchivementModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        gold={gold}
        silver={silver}
        bronze={bronze}
        // AchievementType={AchievementType}
        title={title}
      />
    </div>
  );
}

export default AchievementsCard;
